import { Component, Vue } from "vue-property-decorator";
import DashboardCardList from "@/modules/Dashboards/components/DashboardCardList/DashboardCardList.vue";
import {
  DASHBOARD_CONST,
  INFO_CARD_TEMPLATE
} from "../constants/DashboardConstants";
import { DashboardCard } from "../models/DashboardCard";
import { LOCAL_STORAGE } from "@/shared/constants/FormConstants";

@Component({
  name: "TemplateDashboard",
  components: { DashboardCardList }
})
export default class TemplateDashboard extends Vue {
  TITLE = "";

  listCard: DashboardCard[] = [];

  mounted() {
    this.listCard = [INFO_CARD_TEMPLATE];
    this.TITLE =
      DASHBOARD_CONST.HOME.TITLE +
      localStorage.getItem(LOCAL_STORAGE.USER_NAME);
  }
}
